import { TyreBrandWithTyreModelOutputTyreModelData } from './tyre-brand-with-tyre-model-output-tyre-model-data.model';


export class TyreBrandWithTyreModelOutputData implements ITyreBrandWithTyreModelOutputData {
    /** The auto-generated id of the tyre brand master */
    tyre_brand_id!: number;
    /** The tyre brand name with 255 character limit */
    tyre_brand_name!: string;
    tyre_model!: TyreBrandWithTyreModelOutputTyreModelData[];

    constructor(data?: ITyreBrandWithTyreModelOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tyre_brand_id = _data["tyre_brand_id"];
            this.tyre_brand_name = _data["tyre_brand_name"];
            if (Array.isArray(_data["tyre_model"])) {
                this.tyre_model = [] as any;
                for (let item of _data["tyre_model"])
                    this.tyre_model!.push(TyreBrandWithTyreModelOutputTyreModelData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TyreBrandWithTyreModelOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new TyreBrandWithTyreModelOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tyre_brand_id"] = this.tyre_brand_id;
        data["tyre_brand_name"] = this.tyre_brand_name;
        if (Array.isArray(this.tyre_model)) {
            data["tyre_model"] = [];
            for (let item of this.tyre_model)
                data["tyre_model"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITyreBrandWithTyreModelOutputData {
    /** The auto-generated id of the tyre brand master */
    tyre_brand_id: number;
    /** The tyre brand name with 255 character limit */
    tyre_brand_name: string;
    tyre_model: TyreBrandWithTyreModelOutputTyreModelData[];
}

